<template>
  <div id="accordion" style="background: transparent; height: 100%; padding: 11px; overflow-y: auto">
    <!-- DxAccordion data source is set to userOptions -->
    <DxAccordion :data-source="userOptions" id="accordion-container" width="100%" :collapsible="true" :selected-index="-1" item-title-template="itemTitle" item-template="item">
      <template #itemTitle="{ data }">
        <div><font-awesome-icon :icon="data.icon" style="padding-right: 11px" /> {{ data.name }}</div>
      </template>
      <template #item="{ data }">
        <!-- <div>
          <span>Option ID: {{ data.id }}</span> <br />
          <span>Option Name: {{ data.name }}</span>
        </div> -->
        <div v-if="data.id === 1" class="container-xxl">
          <div class="row">
            <div class="col">
              <div class="container-xxl">
                <div>
                  <b-row no-gutters>
                    <b-col class="text-right p-2 m-0">
                      <h5>{{ userStore._user.name }}</h5>
                    </b-col>
                    <b-col class="text-left p-0 m-0">
                      <LogOutButton />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="data.id === 2" class="container-xxl">
          <div class="container-xxl">
            <!-- <div>Show list of roles assigned to the user (read only)</div> -->
            <div>
              ROLES :
              <ul class="list-unstyled">
                <li v-for="(role, index) in userStore.roles" :key="index" class="py-1">
                  <!-- <div class="badge bg-primary mb-1">Role #{{ index + 1 }}</div> -->
                  <div class="ms-3 small" style="margin-left: 35%">
                    <strong>{{ role.name }}</strong>
                    <!-- <strong> : {{ role.role }}</strong> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="data.id === 3" class="container-xxl">
          <ThemeToggle />
        </div>
        <div v-if="data.id === 4" class="container-xxl">
          <UserProfileLogin class="form" :user="userStore._user" @userProfileLogin="onSubmitUserProfileLogin" />
        </div>
      </template>
    </DxAccordion>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// ! API
import { setUserSessionVariable, fetchSessionVariable } from "@/api/userApi";
import { toast } from "vue3-toastify";

import DxAccordion from "devextreme-vue/accordion";

import LogOutButton from "./LogOutButton.vue";
import ThemeToggle from "@/components/ThemeToggle.vue";
import UserProfileLogin from "./UserProfileLogin.vue";

const userOptions = ref([
  // { id: 1, name: "User Name" },
  { id: 3, name: "Theme", icon: ["fas", "palette"] },
  { id: 4, name: "EMR Credentials", icon: ["fas", "key"] },
  { id: 2, name: "User Roles", icon: ["fas", "user-tag"] },
]);

const AreIdsShown = ref(false);

async function onSubmitUserProfileLogin(form) {
  //SaveUserProfile([FromBody] EMRCredentialsRequest request)

  // replace withe new Cont Stub (obj)

  // console.log("Form Data:", form);

  // Save userName
  const userNamePayload = {
    variableName: "userName",
    variableValue: form.userName,
  };
  // console.log("Saving userName:", userNamePayload);
  toast.success("Saving user's userName to server.");
  const userNameResult = await setUserSessionVariable(userNamePayload);
  // console.log("Result for userName:", userNameResult);

  // Save userPassword
  const userPasswordPayload = {
    variableName: "userPassword",
    variableValue: form.userPassword,
  };
  // console.log("Saving userPassword:", userPasswordPayload);
  toast.success("Saving user's userPassword to server.");
  const userPasswordResult = await setUserSessionVariable(userPasswordPayload);
  // console.log("Result for userPassword:", userPasswordResult);

  // Optionally, refresh user data or handle post-save logic here
  await userStore.fetchUserData();
}

onMounted(() => {
  // console.log("onMounted() :      UP ACC >>>>");
});
</script>

<style scoped>
:deep(.dx-item.dx-accordion-item.dx-accordion-item-closed) {
  height: 32px !important;
}
</style>
